import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BOOKING_URL } from "@/lib/site";
import { MaskReveal, Reveal } from "../Reveal";
import { PHOTO_SIZES, PHOTOS } from "../images";

export function TentCampingSection() {
  const photo = PHOTOS.coveredParking;

  return (
    <section
      id="tent-camping"
      className="scroll-mt-28 bg-background py-24 sm:py-28"
      aria-labelledby="tent-title"
    >
      <div className="mx-auto grid max-w-[1400px] items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-10">
        <MaskReveal className="media-zoom order-1 rounded-sm lg:order-2">
          <img
            src={photo.src}
            srcSet={photo.srcSet}
            sizes={PHOTO_SIZES.half}
            alt={photo.alt}
            width={photo.width}
            height={photo.height}
            loading="lazy"
            decoding="async"
            className="aspect-[16/10] w-full rounded-sm object-cover"
          />
        </MaskReveal>

        <div className="order-2 lg:order-1">
          <Reveal>
            <p className="eyebrow text-clay">Sleep Under the South Texas Sky</p>
            <h2
              id="tent-title"
              className="mt-4 font-display text-3xl leading-tight sm:text-4xl lg:text-[2.7rem]"
            >
              Tent Camping at Amigo Inn
            </h2>
            <p className="mt-6 text-base leading-relaxed text-muted-foreground sm:text-lg">
              Tent campers can enjoy a relaxed outdoor stay while remaining close to Amigo
              Inn&apos;s campground conveniences. Current tent-site options may include shade, water
              access, electric service, Wi-Fi, nearby showers, and access to fishing and recreation.
            </p>
          </Reveal>

          <Reveal delay={0.1} className="mt-8">
            <Button asChild variant="forest" size="cta">
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
                Check Tent-Site Availability <ArrowUpRight aria-hidden="true" />
              </a>
            </Button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
